export const heroImg = {
  phone: '/images/phone.png.webp',
  laptop: '/images/laptop.png.webp',
};

export const logo = '/images/Logo.png.webp';
